export const cars = [
  {
    id: 1,
    platenumber: "ROB192",
    name: "Ford Focus 3 Kombi",
    year: 2012,
    color: "Fehér",
    body: "Kombi",
    engine: "1600 cm3 Diesel",
    motorway: "Éves országos",
    towbar: "Nincs",
    category: "III.",
    price_1: "12.000 Ft/nap",
    price_2_3: "11.000 Ft/nap",
    price_4_10: "10.000 Ft/nap",
    deposit: "60.000 Ft",
    image: "/images/fleet/focus3_white_2012.webp",
  },
  {
    id: 2,
    platenumber: "NKG244",
    name: "Ford Focus 3 Kombi",
    year: 2012,
    color: "Fekete",
    body: "Kombi",
    engine: "1600 cm3 Diesel",
    motorway: "Éves országos",
    towbar: "Nincs",
    category: "III.",
    price_1: "12.000 Ft/nap",
    price_2_3: "11.000 Ft/nap",
    price_4_10: "10.000 Ft/nap",
    deposit: "60.000 Ft",
    image: "/images/fleet/focus3_black_2012.webp",
  },
  {
    id: 3,
    platenumber: "RLK457",
    name: "Ford Focus 3.5 Kombi",
    year: 2018,
    color: "Szürke",
    body: "Kombi",
    engine: "1600 cm3 Diesel",
    motorway: "Éves országos",
    towbar: "Nincs",
    category: "II.",
    price_1: "16.000 Ft/nap",
    price_2_3: "14.000 Ft/nap",
    price_4_10: "13.000 Ft/nap",
    deposit: "60.000 Ft",
    image: "/images/fleet/focus35_grey_2018.webp",
  },
  {
    id: 4,
    platenumber: "AEDQ696",
    name: "Ford Focus 3.5 Kombi",
    year: 2018,
    color: "Szürke",
    body: "Kombi",
    engine: "1600 cm3 Diesel",
    motorway: "Éves országos",
    towbar: "Nincs",
    category: "II.",
    price_1: "16.000 Ft/nap",
    price_2_3: "14.000 Ft/nap",
    price_4_10: "13.000 Ft/nap",
    deposit: "60.000 Ft",
    image: "/images/fleet/focus35_grey_2018_2.webp",
  },
  {
    id: 5,
    platenumber: "MIT842",
    name: "Ford Mondeo IV Kombi",
    year: 2013,
    color: "Fekete",
    body: "Kombi",
    engine: "2000 cm3 Diesel",
    motorway: "Éves országos",
    towbar: "Nincs",
    category: "III.",
    price_1: "12.000 Ft/nap",
    price_2_3: "11.000 Ft/nap",
    price_4_10: "10.000 Ft/nap",
    deposit: "60.000 Ft",
    image: "/images/fleet/mondeo4_black_2013.webp",
  },
  {
    id: 6,
    platenumber: "PMD129",
    name: "Ford Mondeo V Kombi",
    year: 2018,
    color: "Szürke",
    body: "Kombi",
    engine: "2000 cm3 Diesel",
    motorway: "Éves országos",
    towbar: "Van",
    category: "II.",
    price_1: "17.000 Ft/nap",
    price_2_3: "15.000 Ft/nap",
    price_4_10: "14.000 Ft/nap",
    deposit: "60.000 Ft",
    image: "/images/fleet/mondeo5_grey_2018.webp",
  },
  {
    id: 7,
    platenumber: "AEEH935",
    name: "Ford Mondeo V Kombi",
    year: 2018,
    color: "Szürke",
    body: "Kombi",
    engine: "2000 cm3 Diesel",
    motorway: "Éves országos",
    towbar: "Van",
    category: "I.",
    price_1: "17.000 Ft/nap",
    price_2_3: "15.000 Ft/nap",
    price_4_10: "14.000 Ft/nap",
    deposit: "60.000 Ft",
    image: "/images/fleet/mondeo5_grey_2018_2.webp",
  },
  {
    id: 8,
    platenumber: "RZV480",
    name: "Ford Mondeo V Kombi",
    year: 2018,
    color: "Fehér",
    body: "Kombi",
    engine: "2000 cm3 Diesel",
    motorway: "Éves országos",
    towbar: "Van",
    category: "I.",
    price_1: "17.000 Ft/nap",
    price_2_3: "15.000 Ft/nap",
    price_4_10: "14.000 Ft/nap",
    deposit: "60.000 Ft",
    image: "/images/fleet/mondeo5_white_2018.webp",
  },
  {
    id: 9,
    platenumber: "RFV809",
    name: "Ford Mondeo V Ferdehátú",
    year: 2015,
    color: "Szürke",
    body: "Ferdehátú",
    engine: "2000 cm3 Diesel",
    motorway: "Éves országos",
    towbar: "Van",
    category: "II.",
    price_1: "17.000 Ft/nap",
    price_2_3: "15.000 Ft/nap",
    price_4_10: "14.000 Ft/nap",
    deposit: "60.000 Ft",
    image: "/images/fleet/mondeo5_hatch_2015.webp",
  },
];
